import { ToolsTranslations } from '@/lib/translations/types';

export interface InterestCoverageValues { ebt: number; interestExpense: number }
export interface InterestCoverageResult { ratio: number | null; isValid: boolean; message?: string }

// Interest coverage = EBT / Interest expense
export function calculateInterestCoverage(values: InterestCoverageValues, t?: ToolsTranslations['interestCoverage']): InterestCoverageResult {
  const { ebt, interestExpense } = values;
  if (ebt < 0) return { ratio: null, isValid: false, message: t?.invalid.ebt };
  if (interestExpense <= 0) return { ratio: null, isValid: false, message: t?.invalid.interestExpense };
  const raw = ebt / interestExpense;
  const ratio = Math.round(raw * 100) / 100; // 2 decimals
  if (!isFinite(ratio)) return { ratio: null, isValid: false, message: t?.invalid.generic };
  return { ratio, isValid: true };
}


